import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/translation/editor/translation.upsert.mutation.gql"
import type {
  TranslationUpsertMutation,
  TranslationUpsertMutationVariables,
} from "@/v2-backoffice-client/translation/editor/__types__/translation.upsert.mutation"

type Options = MutationHookOptions<
  TranslationUpsertMutation,
  TranslationUpsertMutationVariables
>

// Intentionally no refetchQueries: "Save all" fires one upsert per language
// in parallel, so the caller refetches the catalog once when the batch is
// done instead of once per mutation.
export function useTranslationUpsertMutation(options?: Options) {
  return useMutation<
    TranslationUpsertMutation,
    TranslationUpsertMutationVariables
  >(mutation, options)
}
